import React from 'react';
import FrontSliderBlurb from "./FrontSliderBlurb";
import RatingItem from "./RatingItem";
import {contentURL} from "src/utilities/utilityFunctions";

const WatchFromNextRoomSlide=(props)=>{
    return (
        <div className="ls-slide" data-ls="slidedelay:8500; transition2d: all;" id="watchFromTheNextRoom">

            <img src={contentURL() +  "/site/images/layerslider-gallery-tn/spy-background.png"}
                 className="ls-bg" alt="Slide background"/>

            <img className="ls-l" style={{top:"385px",left:"-584px",whiteSpace: "nowrap"}}
             data-ls="offsetxin:191;offsetyin:550;delayin:1500;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/spy-bungee.png"} alt=""/>

         <img className="ls-l" style={{height:"100%",top:"0px",left:"-227px",whiteSpace: "nowrap"}}
          data-ls="offsetxin:-250;delayin:200;-offsetxout:-20;parallaxlevel:0;"
          src={contentURL() +  "/site/images/layerslider-gallery/L-shadow2.png"} alt=""/>

            <img className="ls-l" style={{top:"430px",left:"-302px",whiteSpace: "nowrap"}}
             data-ls="offsetxin:82;offsetyin:550;delayin:1750;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/spy-surprise.png"} alt=""/>

            <img className="ls-l" style={{top:"251px",left:"-93px",whiteSpace: "nowrap"}}
             data-ls="offsetxin:0;offsetyin:550;delayin:2000;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/spy-paintface.png"} alt=""/>

            <img className="ls-l" style={{top:"416px",left:"1002.6px",whiteSpace: "nowrap"}}
             data-ls="offsetxin:0;offsetyin:550;delayin:2250;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/spy-poster-girl.png"} alt=""/>

            <img className="ls-l" style={{top:"240px",left:"1151px",whiteSpace: "nowrap"}}
             data-ls="offsetxin:126;offsetyin:550;delayin:2500;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/spy-jumper.png"} alt=""/>

            <img className="ls-l" style={{top:"86px",left:"1282px",whiteSpace: "nowrap"}}
             data-ls="offsetxin:202;offsetyin:550;delayin:2750;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/spy-jetman.png"} alt=""/>

            <img className="ls-l" style={{top:"10px",left:"205px",whiteSpace: "nowrap"}}
             data-ls="scalexin:0;scaleyin:0;offsetyin:-100;delayin:3500;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/clouds.png"} alt=""/>

             <img className="ls-l" style={{top:"104px",left:"81px",whiteSpace: "nowrap"}}
             data-ls="scalexin:0;scaleyin:0;delayin:4700;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/bottom-rays.png"} alt=""/>

             <img className="ls-l" style={{top:"-150px",left:"145px",whiteSpace: "nowrap"}}
             data-ls="scalexin:0;scaleyin:0;delayin:4700;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/top-rays.png"} alt=""/>

            <img className="ls-l" style={{top:"70px",left:"255px",whiteSpace: "nowrap"}}
             data-ls="scalexin:0;scaleyin:0;offsetyin:-100;delayin:4200;-offsetxout:-20;parallaxlevel:0;easingin:easeOutBack;"
             src={contentURL() +  "/site/images/layerslider-gallery/guiding-eye.png"} alt=""/>




            <img className="ls-l" style={{height:"100%",top:"0px",left:"-460px",whiteSpace: "nowrap"}}
             data-ls="offsetxin:-250;delayin:400;-offsetxout:-20;parallaxlevel:0;"
             src={contentURL() +  "/site/images/layerslider-gallery/L-shadow3.png"} alt=""/>


            <img className="ls-l" style={{height:"100%",top:"0px",left:"1100px",whiteSpace: "nowrap"}}
             data-ls="offsetxin:250;delayin:200;-offsetxout:-20;parallaxlevel:0;"
             src={contentURL() +  "/site/images/layerslider-gallery/R-shadow2.png"} alt=""/>

            <img className="ls-l" style={{height:"100%",top:"0px",left:"1228px",whiteSpace: "nowrap"}}
             data-ls="offsetxin:250;delayin:400;-offsetxout:-20;parallaxlevel:0;"
             src={contentURL() +  "/site/images/layerslider-gallery/R-shadow3.png"} alt=""/>
            <div className="ls-l"
                 style={{top:"105px",left:"1350px"}}
                 data-ls="offsetxin:500;offsetyin:0;delayin:3500;easingin:easeOutQuart;offsetxout:500;offsetyout:0;parallaxlevel:1;"
                 key="blurb"
            >
                <FrontSliderBlurb delay="0" show="true"
                                  blurb={"Watch them and their playlist remotely. Play, pause, skip or stop from the next room on your computer or device."}/>
            </div>,

            <RatingItem yeatitle={"...I LOVE this!!"}
                        mehtitle={"...I could go for it. Maybe."}
                        naytitle={"...I don't see the point."} bgcolor={"#EEEEEE"}
                        top={450} left={1050}
                        audience={"adult"}
                        feature={"dpmonitor"} label={"As an adult..."} key="sliderImage16"/>,
            <RatingItem yeatitle={"LOVE this!!"}
                        mehtitle={"take It Or Leave It"}
                        naytitle={"not like this."} bgcolor={"#EEEEEE"}
                        top={459} left={1050} audience={"child"}
                        feature={"dpmonitor"}
                        label={"My child will..."}
                        key="sliderImage17"/>
        </div>
    )
};
export default WatchFromNextRoomSlide;
